import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { VolunteeringAreaService } from '../volunteering-area.service';
import { VolunteeringAllVolunteersTab1Part } from './tabs/tab-1/volunteering-all-volunteers-tab-1.part';
import { VolunteeringAllVolunteersTab2Part } from './tabs/tab-2/volunteering-all-volunteers-tab-2.part';
import { VolunteeringAllVolunteersViewsPart } from './views/volunteering-all-volunteers-views.part';
import { VolunteeringAllVolunteersService } from './volunteering-all-volunteers.service';

@Component({
	selector: 'volunteering-all-volunteers-page',
	standalone: true,
	imports: [
		VolunteeringAllVolunteersViewsPart,
		VolunteeringAllVolunteersTab1Part,
		VolunteeringAllVolunteersTab2Part,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-all-volunteers.page.html',
})
export class VolunteeringAllVolunteersPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public areaService = inject(VolunteeringAreaService);
	public pageService = inject(VolunteeringAllVolunteersService);
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}